module.exports = __webpack_public_path__ + "img/app_qrcode.c34a86b3.png";